import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateAffectedStaffPas({ id, pas }: { id: number; pas: number | null }) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.updateAffectedStaffPas.url, { id }))
    .patch({ amount: pas })
}
